import React from 'react'
import VendorManagement from '../../Component/VendorManagement'
import { Box } from '@mui/material'

const Index = () => {
  return (
    <Box padding={"25px"}>
      <VendorManagement />
    </Box>
  )
}

export default Index